import Footer from '@/components/footer/FooterWrapper';
import LandingPage, { jayCustomSeo } from '@/components/jay/JayLandingPageLayout';
import Layout from '@/components/layout/LayoutWrapper';

const DailyJayPage = () => {
	return (
		<Layout pageName="daily_jay" title="Calm - The Daily Jay" customSeo={jayCustomSeo}>
			<LandingPage isTrialFlow />
			<Footer initialTheme="light" />
		</Layout>
	);
};

export default DailyJayPage;

export { getServerSideProps } from '@/utils/pageGeneration/getServerSideProps';
